module.exports = __webpack_public_path__ + "img/0001.01716a1e.jpg";